import { Close } from '@carbon/icons-react'
import React from 'react'
import SvgPreview from './PreviewSVG'
import pallete from '../../../global/newPallete'

interface MediaPreviewModalProps {
  isPreviewOpen: boolean
  handleClosePreview: () => void
  previewFile: string
}

const MediaPreviewModal: React.FC<MediaPreviewModalProps> = ({
  isPreviewOpen,
  handleClosePreview,
  previewFile
}) => {
  if (!isPreviewOpen) return null

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-gray-500 overflow-y-auto bg-opacity-80 backdrop-blur-sm'>
      <div
        className='relative rounded-lg shadow-lg p-4 max-w-7xl w-full max-h-[90vh] overflow-y-auto flex flex-col'
        style={{
          backgroundColor: pallete.colors.blackBg
        }}
      >
        <button
          onClick={handleClosePreview}
          className='absolute top-[8px] right-[8px] bg-gray-400 text-white p-[4px] rounded-full'
        >
          <Close size={16} />
        </button>

        {previewFile.includes('image') &&
          (previewFile.endsWith('.svg') ? (
            <div className='max-w-full max-h-[80vh] mx-auto'>
              <SvgPreview url={previewFile} />
            </div>
          ) : (
            <img
              src={previewFile}
              alt='preview'
              className='max-w-full max-h-[80vh] mx-auto'
            />
          ))}
      </div>
    </div>
  )
}

export default MediaPreviewModal
